var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0078125,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#808080",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26758 12C5.10742 12 4.97852 11.9512 4.88086 11.8535C4.78711 11.7559 4.74023 11.623 4.74023 11.4551V4.08984C4.74023 3.92187 4.78711 3.78906 4.88086 3.69141C4.97852 3.59375 5.10742 3.54492 5.26758 3.54492H7.58203C8.83594 3.54492 9.81445 3.91797 10.5176 4.66406C11.2207 5.40625 11.5723 6.44141 11.5723 7.76953C11.5723 9.10156 11.2207 10.1406 10.5176 10.8867C9.81836 11.6289 8.83984 12 7.58203 12H5.26758ZM5.79492 11.0508H7.51172C8.46875 11.0508 9.20508 10.7695 9.7207 10.207C10.2363 9.64062 10.4941 8.83203 10.4941 7.78125C10.4941 6.72266 10.2363 5.91016 9.7207 5.34375C9.20898 4.77734 8.47266 4.49414 7.51172 4.49414H5.79492V11.0508Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.642cba28532abecca71a8cc7dbe537c1.svg";
export { ForwardRef as ReactComponent };